import React, {Component} from 'react';
import { translate, Trans } from "react-i18next";
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import {required,email,isValidForm} from '../../server/validationMethods.js';
import {IncomFreqency,IncomType} from '../Parent/SchoolLunchBreakfastProgram/schoolLunchBreakfastModal';
import Draft from './draft.js';
class RacialEthnic extends Component {
render(){
   return(
        <div>
            <div className="row">
                <div className="col-xs-12 block">
                    <div className="schoolInfo">
                        <p><strong><Trans>This is an optional question for information we collect about students that attend school in</Trans> {this.props.schoolInfo.name}.</strong></p>
                        <p><Trans>We are required to ask for information about the race and ethnicity of the students that are applying for the program</Trans>.</p>
                        <p><Trans>This information is important and helps to make sure we are fully serving our community</Trans>. <Trans>Responding to this section is optional and does not affect your children's eligibility for free or reduced price meals</Trans>.</p>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12">
                    <div className="row">                    
                    {
                    this.props.lunchObj.studentList.map((item,k)=>{ 
                        if(item.isSelected===true)  {                    
                            return(
                                <div className="row">
                                        <div className="col-md-12">
                                        <h5>{item.lname+' '+item.fname}</h5>
                                        <div className="col-md-4">
                                            <label><Trans>{'Ethnicity'}</Trans></label>
                                            <div className="styled-input-container styled-input--rounded">
                                            <div className="styled-input-single" style={{padding: '0px 0px 0px 33px'}}>
                                            <input type="radio" id={"ethnicity"+k} name={"ethnicity"+k} data-idx={k} checked={item.ethenticity==='Hispanic or Latino'} onChange={(e)=>{
                                                let idx=e.target.getAttribute('data-idx');                                                
                                                this.props.onEthnicChange(idx,'ethenticity',e.target.checked?'Hispanic or Latino':'')

                                            }} /> <label htmlFor={"ethnicity"+k}><Trans>Hispanic or Latino</Trans></label>
                                            </div></div>
                                            <div className="styled-input-container styled-input--rounded">
                                            <div className="styled-input-single" style={{padding: '0px 0px 0px 33px'}}>
                                            <input type="radio" id={"nethnicity"+k} name={"ethnicity"+k} data-idx={k} checked={item.ethenticity==='Not Hispanic or Latino'} onChange={(e)=>{
                                                let idx=e.target.getAttribute('data-idx')
                                                this.props.onEthnicChange(idx,'ethenticity',e.target.checked?'Not Hispanic or Latino':'')
                                            }} /> <label htmlFor={"nethnicity"+k}><Trans>Not Hispanic or Latino</Trans></label>
                                            </div></div>
                                        </div>
                                        <div className="col-md-6">
                                        <label><Trans>{'Race'}</Trans></label>
                                        <div className="styled-input-container styled-input--square">
                                            <div className="styled-input-single" style={{padding:'1px 0px 5px 40px'}}>
                                        <input type="checkbox" id={"AIAN"+k} name={"AIAN"+k} data-idx={k} 
                                        checked={(item.race).includes('American Indian or Alaskan Native')} 
                                        onChange={(e)=>{
                                                let idx=e.target.getAttribute('data-idx')            
                                                this.props.onRacialChange(idx,'American Indian or Alaskan Native',e.target.checked?true:false)
                                            }} /> <label htmlFor={"AIAN"+k}><Trans>American Indian or Alaskan Native</Trans></label>
                                            </div></div>
                                            <div className="styled-input-container styled-input--square">
                                            <div className="styled-input-single" style={{padding:'1px 0px 5px 40px'}}>
                                            <input type="checkbox" id={"Asian"+k} name={"Asian"+k} data-idx={k} 
                                            checked={item.race.includes('Asian')} 
                                            onChange={(e)=>{
                                                let idx=e.target.getAttribute('data-idx')            
                                                this.props.onRacialChange(idx,'Asian',e.target.checked?true:false)
                                            }} /> <label htmlFor={"Asian"+k}><Trans>Asian</Trans></label>
                                            </div></div>
                                            <div className="styled-input-container styled-input--square">
                                            <div className="styled-input-single" style={{padding:'1px 0px 5px 40px'}}>
                                            <input type="checkbox" id={"BAA"+k} name={"BAA"+k} data-idx={k} 
                                            checked={item.race.includes('Black or African American')} 
                                            onChange={(e)=>{
                                                let idx=e.target.getAttribute('data-idx')            
                                                this.props.onRacialChange(idx,'Black or African American',e.target.checked?true:false)
                                            }} /> <label htmlFor={"BAA"+k}><Trans>Black or African American</Trans></label></div></div>
                                            <div className="styled-input-container styled-input--square">
                                            <div className="styled-input-single" style={{padding:'1px 0px 5px 40px'}}>
                                            <input type="checkbox" id={"NHOPI"+k} name={"NHOPI"+k} data-idx={k} 
                                            checked={item.race.includes('Native Hawaiian or Other Pacific Islander')} 
                                            onChange={(e)=>{
                                                let idx=e.target.getAttribute('data-idx')            
                                                this.props.onRacialChange(idx,'Native Hawaiian or Other Pacific Islander',e.target.checked?true:false)
                                            }} /> <label htmlFor={"NHOPI"+k}><Trans>Native Hawaiian or Other Pacific Islander</Trans></label>
                                             </div></div>
                                            <div className="styled-input-container styled-input--square">
                                            <div className="styled-input-single" style={{padding:'1px 0px 5px 40px'}}>
                                            <input type="checkbox" id={'White'+k} name={"White"+k} data-idx={k} 
                                            checked={item.race.includes('White')}  
                                            onChange={(e)=>{
                                                let idx=e.target.getAttribute('data-idx')            
                                                this.props.onRacialChange(idx,'White',e.target.checked?true:false)
                                            }} /> <label htmlFor={'White'+k}><Trans>White</Trans></label>
                                            </div></div>
                                        </div>
                                    </div>
                                </div>
                                )} 
                    })
                }
                    </div>
                </div>
            </div> 
            <div className="row">
                <div className="col-xs-12">
                        <button className="btn btn-next bg-color-4 btn-xs pull-left" onClick={(e)=>{
                        this.props.jumpToStep(12)
                    }}>
                        <Trans>Previous</Trans>
                    </button>
                    <button className="btn btn-prev btn-xs bg-color-2 pull-right" onClick={(e)=>{
                        this.props.jumpToStep(14);
                    }}><Trans>Continue</Trans>
                    </button>
                    <Draft lunchObj={this.props.lunchObj} schoolInfo={this.props.schoolInfo} />
                </div>
            </div>
        </div>
    )
}
}
export default RacialEthnic;


// WEBPACK FOOTER //
// ./src/components/FreeReducedProgram/racialEthnic.jsx